import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'filter'
})

@Injectable()
export class FilterPipe implements PipeTransform {

    transform(items: any[], term: string, obj: any): any[] {
        if (term === undefined) {
            return items;
        }
        // console.log('filter',term,obj,items)

        function traverse(item) {
            for (let property in item) {
                if (item[property] === null) {
                    continue;
                }
                if (typeof item[property] === 'object') {
                    if(traverse(item[property]))
                        return true;
                } else {
                    if (item[property].toString().toLowerCase().includes(term.toLowerCase())) {
                        return true;
                    }
                }
            }
            return false;
        }

        if (items) {
            return items.filter(function (item) {
                for (let property in item) {
                    if (item[property] === null) {
                        continue;
                    }
                    if (typeof item[property] === 'object') {
                        if (traverse(item[property])) {
                            return true;
                        }
                    } else {
                        if (item[property].toString().toLowerCase().includes(term.toLowerCase())) {
                            return true;
                        }
                    }
                }
                return false;
            });
        }
    }

}
